import React from 'react';
import LoginForm from '../../forms/Login';
import centredForm from '../components/centredForm';
import FormTitle from '../components/FormTitle';

export default centredForm(LoginForm, <FormTitle title="logInTitle" />, 350);



// WEBPACK FOOTER //
// ./src/view/scenes/LoginPage/index.js